"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBCHAT_UPSELL_LINK = void 0;
exports.WEBCHAT_UPSELL_LINK = "https://web.snapchat.com?ref=upsell_toast"; // TODO: Check w/ Alex what ref they want here.
//# sourceMappingURL=upsell-link.js.map